import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SubscriptionLike, Observable } from 'rxjs';
import { EventManagerService } from 'src/app/core/services/event-manager.service';
import { Spinner } from 'src/app/core/services/spinner.service';
import { PlayVideoDialogComponent } from 'src/app/shared/components/play-video-dialog/play-video-dialog.component';
import { TYPE_FILE } from 'src/app/shared/enums/data-mock-enums';
import { ApplicationTrainingDocument } from 'src/app/shared/model/application-training-document.model';
import { ApplicationTrainingDocumentDetailService } from 'src/app/shared/service/application-training-document-detail.service';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-application-training-document',
  templateUrl: './application-training-document.component.html',
  styleUrls: ['./application-training-document.component.scss'],
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    '(window:resize)': 'onWindowResize($event)'
  }
})
export class ApplicationTrainingDocumentComponent implements OnInit, OnDestroy {
  typeFile = TYPE_FILE;
  isShow = true;
  isMobile = false;
  width: number = window.innerWidth;
  height: number = window.innerHeight;
  mobileWidth = 760;
  role: string;
  supportList = [];
  selectedItem: number;
  applicationDocumentList: ApplicationTrainingDocument[] = [];
  subscription: SubscriptionLike;
  listAppName: string[] = [];
  nameControl: FormControl = new FormControl();
  filteredOptions: Observable<any[]>;
  isRSP: boolean = false;

  constructor(
    private dialog: MatDialog,
    private spinner: Spinner,
    private documentService: ApplicationTrainingDocumentDetailService,
    private eventManager: EventManagerService,
    private router: Router) { }

  ngOnInit(): void {
    if (localStorage.getItem(btoa('isRSP')) && atob(localStorage.getItem(btoa('isRSP'))) !== 'true') {
      this.router.navigateByUrl('/');
    } else {
      if (localStorage.getItem(btoa('role'))) {
        this.role = atob(localStorage.getItem(btoa('role')));
      }
      this.getApplicatiponTrainingDocuments();
      this.eventManager.subscribe('SHOW_SIDEBAR', (res) => {
        this.isShow = res.data.isShow;
      });
      this.role = atob(localStorage.getItem(btoa('role')));
      this.isMobile = this.width < this.mobileWidth;
      this.filteredOptions = this.nameControl.valueChanges.pipe(
        startWith(''),
        map(value => this.filter(value))
      );
    }
    
  }

  ngOnDestroy() {
    // unsubscribe
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getApplicatiponTrainingDocuments() {
    this.spinner.show();
    this.subscription = this.documentService.getApplicationTrainingDocumentPublish().subscribe((res) => {
      this.spinner.hide();
      this.applicationDocumentList = res.data;
      // get list app name
      this.listAppName = this.applicationDocumentList.reduce((a, b) => [...a, b.name, ...b.materials.map(x => b.name + '-' + x.name)], []);

      res.data.forEach((item) => {
        this.supportList.push({name: item.name, id: item.id});
      });
      this.selectedItem = this.supportList[0] ? this.supportList[0].id : -1;
    });
  }

  onWindowResize(event) {
    this.width = event.target.innerWidth;
    this.height = event.target.innerHeight;
    this.isMobile = this.width < this.mobileWidth;
    if (this.width < this.mobileWidth) {
      this.isShow = true;
    }
  }

  onClick(item): void {
    this.selectedItem = item;
  }

  openDialog(src) {
    const dialogRef = this.dialog.open(PlayVideoDialogComponent, {
      width: this.width > 1000 ? '65%' : '100%',
      maxHeight: '85%',
      maxWidth: '100%',
      data: {
        type: 'Play video Training',
        url: src,
      }
    });
  }

  clickApplicationDocument(item, idx): void {
    const itemApplicationDocument = this.applicationDocumentList.filter(data => data.name === item);
    const value = itemApplicationDocument[0].materials[idx];
    if (value.type === TYPE_FILE.DOCUMENT) {
      const url = value.resource ? value.resource.resourceUrl : value.url;
      window.open(url, '_blank');
    } else if (value.type === TYPE_FILE.VIDEO) {
      this.openDialog(value.url);
    }
  }

  getListEmailSupport() {
    const itemApplicationDocument = this.applicationDocumentList.filter(data => data.id === this.selectedItem);
    const value = itemApplicationDocument.length ? itemApplicationDocument[0].emails : [];
    return value;
  }

  private filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.listAppName.filter(option => option.toLowerCase().includes(filterValue));
  }

  public optionSelected(event) {
    window.location.href = '/application-training-document#' + event.option.value;
  }

}
